import React from 'react';

class SystemsContact extends React.Component {
    render(){
        return(
            <section className="connect">
                <div className="container"><h2 className="connect__title">Связь с системами анкетирования</h2><p
                    className="connect__text"><b>DEX</b> архитектурно независим от систем анкетирования и сбора
                    данных. Любые параметры, идентифицирующие контакт и текущий проект, могут быть переданы любому стороннему веб-сервису 
                    в момент установления соединения с оператором.</p></div>
            </section>
        )
    }
}

export default SystemsContact;


// WEBPACK FOOTER //
// ./src/Components/DialerExpress/SystemsContact.js